import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/pages/Home.vue'
import Contact from '@/pages/Contact.vue'
import AboutUs from '@/pages/AboutUs.vue'
import Services from '@/pages/Services.vue'

const routes = [
  {
    path: '/',
    component: Home,
    meta: {
      title: 'Arkayl Solutions | Premium Software Development',
      description:
        'Empowering your digital journey with innovative software solutions.'
    }
  },
  {
    path: '/contact',
    component: Contact,
    meta: {
      title: 'Contact Us | Arkayl',
      description:
        'Get in touch with Arkayl Solutions for project estimates and consultations.'
    }
  },
  {
    path: '/about-us',
    component: AboutUs,
    meta: {
      title: 'About Us | Arkayl',
      description:
        'Learn about our story, mission, and the team behind Arkayl Solutions.'
    }
  },
  {
    path: '/services',
    component: Services,
    meta: {
      title: 'Our Services | Arkayl',
      description:
        'Web development, mobile apps, and IT consulting tailored to your business.'
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.afterEach((to) => {
  document.title = to.meta.title || 'Arkayl Solutions'
  const descTag = document.querySelector('meta[name="description"]')
  if (descTag) {
    descTag.setAttribute(
      'content',
      to.meta.description || 'Empowering your digital journey with innovative software solutions.'
    )
  }
})

export default router
